import { render, staticRenderFns } from "./Dot.vue?vue&type=template&id=64c66028"
var script = {}
import style0 from "./Dot.vue?vue&type=style&index=0&id=64c66028&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports